<template>
  <div>
    <v-data-table
        :loading="loading"
        hide-default-footer
        disable-pagination
        :items="items"
        :headers="headers"
    >
      <template #item.start_date="{item}">
        {{ item.start_date|parseDate }}
      </template>
      <template #item.finish_date="{item}">
        {{ item.finish_date|parseDate }}
      </template>
      <template #item.turn_autopayment="{item}">
        {{ item.turn_autopayment ? 'Да' : 'Нет' }}
      </template>
      <template #item.payment_type="{item}">
        {{ item.payment_type|parsePaymentType }}
      </template>
      <template #item.amount="{item}">
        {{ item.amount|money }}
      </template>
      <template #item.status="{item}">
        {{ item.status|parseCreditStatus }}
      </template>
      <template #item.action="{item}">
        <v-btn @click="$router.push({name: 'credit-item', params: {id: item.id}})" class="action-btn" color="success">
          <v-icon small>fas fa-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-pagination
        v-if="lastPage > 1"
        @input="getCreditHistory"
        v-model="params.page"
        :length="lastPage"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  name: "HistoryCredit",
  props: {
    creditId: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: '№',
          value: 'credit_number'
        },
        {
          text: 'Сумма',
          value: 'amount'
        },
        {
          text: 'Дата начала',
          value: 'start_date'
        },
        {
          text: 'Дата окончания',
          value: 'finish_date'
        },
        {
          text: 'Автосписание',
          value: 'turn_autopayment'
        },
        {
          text: 'Статус',
          value: 'status'
        },
        {
          text: '',
          value: 'action'
        }
      ],
      lastPage: 0,
      params: {
        page: 1
      }
    }
  },
  methods: {
    reInit() {
      this.items = []
      this.lastPage = 0
      this.params = {page: 1}
      this.getCreditHistory()
    },
    async getCreditHistory() {
      this.loading = true
      try {
        const {data: {data, links}} = await this.$http.get(`admin/credit/history/${this.creditId}`, {
          params: this.params
        })
        this.items = data
        this.lastPage = links.last_page
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.getCreditHistory()
  }
}
</script>

<style scoped>

</style>